/* import numOne from "../../../Assets/Images/questions/questionSix/numOne.svg";
import numTwo from "../../../Assets/Images/questions/questionSix/numTwo.svg";
import numThree from "../../../Assets/Images/questions/questionSix/numThree.svg";
import numFour from "../../../Assets/Images/questions/questionSix/numFour.svg";
import numFivePlus from "../../../Assets/Images/questions/questionSix/numFivePlus.svg"; */

export const numBedroomsData = [
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171887/AquaHeat/Quote%20Icons/question%206/numOne_jkcns8.svg",
  },
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171887/AquaHeat/Quote%20Icons/question%206/numTwo_amwmnz.svg",
  },
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171887/AquaHeat/Quote%20Icons/question%206/numThree_q3gwkd.svg",
  },
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171887/AquaHeat/Quote%20Icons/question%206/numFour_rlt4uf.svg",
  },
  {
    title: "",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171887/AquaHeat/Quote%20Icons/question%206/numFivePlus_xqytec.svg",
  },
];
